import css from '../styles/styles.module.scss'

import React from 'react'
import { Flex } from 'antd'
// import { StyledBoxProps, StyledDynamicListProps } from './types'
// import { LIST_ITEMS_GAP, PAGE_SIZE } from '../constants'
import { DynamicList } from '@components/common/DynamicList'


// export const StyledBox: React.FC<StyledBoxProps> = ({children, style={}}) => (
//     <Flex
//         align="center"
//         gap={10}
//         style={{ 
//             marginBlock: LIST_ITEMS_GAP,
//             ...style,
//         }}
//     >
//         {children}
//     </Flex>
// )

const PAGE_SIZE = 10

export const StyledCell = ({ children }) => (
    // position: relative — точка отсчёта для списка вариантов: он рендерится
    // внутрь ячейки и позиционируется от её краёв (см. SelectField)
    <Flex style={{ padding: '0 2.5px', height: '30px', position: 'relative' }} align='center' gap={5}>
        {children}
    </Flex>
)

export const StyledDynamicList: React.FC<any> = ({
    responseAdapter,
    load,
    renderItem,
    pageSize = PAGE_SIZE,
}) => (
    <DynamicList
        responseAdapter={responseAdapter}
        loadData={load}
        renderItem={renderItem}
        pageSize={pageSize}
        listProps={{
            style: { marginBlock: `-${10}px` },
            split: false,
        }}
    />
)
